import { BoardViewType } from "app/types";
import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../components/Layout";
import Tickets from "./components/Tickets";

export default function BoardView() {
  const params = useParams();
  const type = params?.type;

  return (
    <Layout>
      <Tickets type={type as BoardViewType} />
    </Layout>
  );
}
